export default __webpack_public_path__ + "static/media/IR_symbol_paths_faint.60908fc2.svg";